import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { guage } from '../content/content.model';

am4core.useTheme(am4themes_animated);
am4core.options.commercialLicense = true;


@Component(
    {
        name: 'guagechart'
    }
)
export default class GuageChartComponent extends Vue {
    @Prop({ required: true })
    guageData!: guage;

    name: string = "";
    id: string = "";
    chart: any;

    mounted() {
        this.name = this.guageData.name!;
        this.id = "chartDiv_" + this.guageData.id!.toString();
    }

    updated() {
        this.generateChart();
    }

    beforeDestroy() {
        if (this.chart)
            this.chart.dispose();
    }

    @Watch('guageData')
    onDataChanged() {
        this.$forceUpdate();
    }

    generateChart() {
        if (this.chart)
            this.chart.dispose();

        // Create chart
        this.chart = am4core.create(this.id, am4charts.GaugeChart);
        // Set inner radius
        this.chart.innerRadius = -20;

        // Create axis
        let axis = this.chart.xAxes.push(new am4charts.ValueAxis<am4charts.AxisRendererCircular>());
        axis.min = 0;
        axis.max = 100;
        axis.strictMinMax = true;
        // axis.renderer.radius = am4core.percent(100);
        axis.renderer.inside = true;
        axis.renderer.line.strokeOpacity = 1;
        axis.renderer.ticks.template.disabled = false;
        axis.renderer.ticks.template.strokeOpacity = 1;
        axis.renderer.ticks.template.length = 10;
        axis.renderer.grid.template.disabled = true;
        axis.renderer.labels.template.radius = 40;

        /**
         * Axis for ranges
         */

        var colorSet = new am4core.ColorSet();

        var axis2 = this.chart.xAxes.push(new am4charts.ValueAxis<am4charts.AxisRendererCircular>());
        axis2.min = 0;
        axis2.max = 100;
        axis2.renderer.innerRadius = 10
        axis2.strictMinMax = true;
        axis2.renderer.labels.template.disabled = true;
        axis2.renderer.ticks.template.disabled = true;
        axis2.renderer.grid.template.disabled = true;

        var range0 = axis2.axisRanges.create();
        range0.value = 0;
        range0.endValue = 50;
        range0.axisFill.fillOpacity = 0.5;
        range0.axisFill.fill = colorSet.getIndex(0);

        var range1 = axis2.axisRanges.create();
        range1.value = 50;
        range1.endValue = 100;
        range1.axisFill.fillOpacity = 0.5;
        range1.axisFill.fill = colorSet.getIndex(2);

        /**
         * Label
         */

        var label = this.chart.radarContainer.createChild(am4core.Label);
        label.isMeasured = false;
        label.fontSize = 20;
        label.x = am4core.percent(50);
        label.y = 5;
        label.horizontalCenter = "middle";
        label.verticalCenter = "bottom";
        label.text = this.guageData.value + "%";


        /**
         * Hand
         */

        var hand = this.chart.hands.push(new am4charts.ClockHand());
        hand.axis = axis2;
        hand.innerRadius = am4core.percent(15);
        hand.startWidth = 4;
        hand.pin.disabled = true;
        hand.value = this.guageData.value;

        hand.events.on("propertychanged", function (ev) {
            range0.endValue = ev.target.value;
            range1.value = ev.target.value;
            axis2.invalidate();
        });
    }
}